<div class="layout-wrapper">

  <!-- ============================================================
       DESKTOP SIDEBAR
       ============================================================ -->
  <aside class="layout-sidebar">

    <!-- Brand -->
    <div class="sidebar-brand">
      <img src="assets/logo.png" alt="Správce přestupů" class="brand-logo" />
      <span class="brand-name">Správce přestupů</span>
    </div>

    <!-- Main navigation -->
    <nav class="sidebar-nav">

      <!-- HLAVNÍ section -->
      <div class="nav-section">
        <span class="nav-section-label">Hlavní</span>
        <ul class="nav-list">
          <li *ngFor="let item of mainItems">
            <a class="nav-item"
               [routerLink]="item.routerLink"
               routerLinkActive="nav-item--active"
               [routerLinkActiveOptions]="{ exact: false }">
              <i [class]="item.icon" class="nav-item-icon"></i>
              <span class="nav-item-label">{{ item.label }}</span>
              <span class="nav-badge-count" *ngIf="item.badge">{{ item.badge }}</span>
            </a>
          </li>
        </ul>
      </div>

      <!-- AGENDA section — coming soon placeholders -->
      <div class="nav-section">
        <span class="nav-section-label">Agenda</span>
        <ul class="nav-list">
          <li *ngFor="let item of agendaItems">
            <div class="nav-item nav-item--coming-soon">
              <i [class]="item.icon" class="nav-item-icon"></i>
              <span class="nav-item-label">{{ item.label }}</span>
              <span class="nav-badge-soon">Brzy</span>
            </div>
          </li>
        </ul>
      </div>

    </nav>

    <!-- Footer: secondary nav + user profile -->
    <div class="sidebar-footer">
      <div class="sidebar-divider"></div>

      <!-- Secondary nav -->
      <ul class="nav-list nav-list--footer">
        <li *ngFor="let item of secondaryItems">
          <a class="nav-item"
             [routerLink]="item.routerLink"
             routerLinkActive="nav-item--active"
             [routerLinkActiveOptions]="{ exact: false }">
            <i [class]="item.icon" class="nav-item-icon"></i>
            <span class="nav-item-label">{{ item.label }}</span>
          </a>
        </li>
      </ul>

      <!-- User row -->
      <div class="sidebar-user">
        <div class="user-avatar-initials">{{ userInitials }}</div>
        <div class="user-details">
          <span class="user-name">{{ currentUser?.firstName }} {{ currentUser?.lastName }}</span>
          <span class="user-email">{{ currentUser?.email }}</span>
        </div>
        <button class="logout-btn" (click)="openChangePasswordDialog()" title="Změnit heslo">
          <i class="pi pi-key"></i>
        </button>
        <button class="logout-btn" (click)="logout()" title="Odhlásit se">
          <i class="pi pi-sign-out"></i>
        </button>
      </div>
    </div>

  </aside>

  <!-- ============================================================
       MOBILE SIDEBAR (p-sidebar overlay)
       ============================================================ -->
  <!-- Vlastní backdrop místo PrimeNG masky ([modal]="false"): řízený *ngIf, takže při
       sidebarVisible=false (klik/NavigationEnd) zmizí okamžitě a nemůže „viset" přes obsah. -->
  <div class="mobile-backdrop" *ngIf="sidebarVisible" (click)="sidebarVisible = false"></div>

  <p-sidebar [(visible)]="sidebarVisible" position="left" [baseZIndex]="10000" [modal]="false" styleClass="mobile-sidebar">
    <div class="mobile-sidebar-inner">

      <!-- Mobile brand header -->
      <div class="mobile-brand">
        <img src="assets/logo.png" alt="Správce přestupů" class="brand-logo-mobile" />
        <span class="brand-name-mobile">Správce přestupů</span>
      </div>

      <!-- Mobile nav content -->
      <div class="mobile-nav">

        <div class="nav-section">
          <span class="nav-section-label nav-section-label--light">Hlavní</span>
          <ul class="nav-list">
            <li *ngFor="let item of mainItems">
              <a class="nav-item nav-item--light"
                 [routerLink]="item.routerLink"
                 routerLinkActive="nav-item--active-light"
                 [routerLinkActiveOptions]="{ exact: false }"
                 (click)="sidebarVisible = false">
                <i [class]="item.icon" class="nav-item-icon"></i>
                <span class="nav-item-label">{{ item.label }}</span>
                <span class="nav-badge-count" *ngIf="item.badge">{{ item.badge }}</span>
              </a>
            </li>
          </ul>
        </div>

        <div class="nav-section">
          <span class="nav-section-label nav-section-label--light">Agenda</span>
          <ul class="nav-list">
            <li *ngFor="let item of agendaItems">
              <div class="nav-item nav-item--light nav-item--coming-soon-light">
                <i [class]="item.icon" class="nav-item-icon"></i>
                <span class="nav-item-label">{{ item.label }}</span>
                <span class="nav-badge-soon nav-badge-soon--light">Brzy</span>
              </div>
            </li>
          </ul>
        </div>

        <div class="mobile-divider"></div>

        <ul class="nav-list">
          <li *ngFor="let item of secondaryItems">
            <a class="nav-item nav-item--light"
               [routerLink]="item.routerLink"
               routerLinkActive="nav-item--active-light"
               [routerLinkActiveOptions]="{ exact: false }"
               (click)="sidebarVisible = false">
              <i [class]="item.icon" class="nav-item-icon"></i>
              <span class="nav-item-label">{{ item.label }}</span>
            </a>
          </li>
        </ul>
      </div>

      <!-- Mobile logout -->
      <div class="mobile-footer">
        <button class="mobile-logout-btn" (click)="openChangePasswordDialog()">
          <i class="pi pi-key"></i>
          <span>Změnit heslo</span>
        </button>
        <button class="mobile-logout-btn" (click)="logout()">
          <i class="pi pi-sign-out"></i>
          <span>Odhlásit se</span>
        </button>
      </div>

    </div>
  </p-sidebar>

  <!-- ============================================================
       MAIN AREA: TOPBAR + CONTENT
       ============================================================ -->
  <div class="layout-main">

    <!-- Topbar -->
    <header class="layout-topbar">

      <div class="topbar-left">
        <!-- Hamburger — mobile only -->
        <button class="topbar-hamburger" (click)="sidebarVisible = true" aria-label="Otevřít menu">
          <i class="pi pi-bars"></i>
        </button>

        <!-- Search -->
        <div class="topbar-search">
          <i class="pi pi-search topbar-search-icon"></i>
          <input type="text"
                 class="topbar-search-input"
                 placeholder="Hledat hráče, klub, přestup…"
                 aria-label="Vyhledávání" />
        </div>
      </div>

      <div class="topbar-right">
        <div class="topbar-user-info">
          <span class="topbar-user-name">{{ currentUser?.firstName }} {{ currentUser?.lastName }}</span>
          <span class="topbar-user-email">{{ currentUser?.email }}</span>
        </div>
        <div class="topbar-avatar" [title]="(currentUser?.firstName || '') + ' ' + (currentUser?.lastName || '')">
          {{ userInitials }}
        </div>
      </div>

    </header>

    <!-- Page content -->
    <main class="layout-content">
      <router-outlet></router-outlet>
    </main>

  </div>
</div>

<!-- Dialog: Změnit heslo -->
<p-dialog [(visible)]="changePasswordDialog" header="Změnit heslo" [modal]="true"
          [style]="{width: '400px'}" styleClass="form-dialog">
  <ng-template pTemplate="content">
    <div class="form-grid">
      <div class="form-group">
        <label class="form-label">Stávající heslo</label>
        <input type="password" pInputText [(ngModel)]="currentPassword" placeholder="••••••••" />
      </div>
      <div class="form-group">
        <label class="form-label">Nové heslo</label>
        <input type="password" pInputText [(ngModel)]="newPassword" placeholder="••••••••" />
        <small class="form-hint">min. 8 znaků</small>
      </div>
      <div class="form-group">
        <label class="form-label">Potvrzení nového hesla</label>
        <input type="password" pInputText [(ngModel)]="confirmPassword" placeholder="••••••••" />
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="dialog-actions">
      <button pButton label="Zrušit" icon="pi pi-times" class="p-button-text p-button-secondary" (click)="changePasswordDialog = false"></button>
      <button pButton label="Změnit heslo" icon="pi pi-key" class="p-button-primary" (click)="submitChangePassword()"></button>
    </div>
  </ng-template>
</p-dialog>
